export default {
  searching: 'Søker',
}
